<template>
    <div>
        <card-header title="Registration Questions" icon="fa-question-circle"></card-header>

        <card-toolbar>
            <button @click="$openCard('rmc-new-question', {confId: conference.id}, card)"><i class="far fa-plus"></i>New Question</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <draggable v-model="conference.metaFields" handle=".handle" @change="updateOrder">
                    <transition-group>
                        <rmc-question-tile
                            :card="card"
                            :question="question"
                            v-for="question in conference.metaFields"
                            :active="(child && child.definition.component === 'rmc-edit-question' && question.id === parseInt(child.props.questionId))"
                            @click="$openCard('rmc-edit-question', {confId: question.conference_id, questionId: question.id}, card)"
                            :key="question.id"
                            class="t-card-list-item"
                        />
                    </transition-group>
                </draggable>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import draggable from 'vuedraggable';

    import {client as http} from "@/http_client";
    import RmcQuestionTile from "../../../components/rmc/RmcQuestionTile";

    export default {
        components: {RmcQuestionTile, CardToolbar, CardList, CardHeader, CardBody, draggable},
        props: ['card', 'props', 'child'],
        data() {
            return {
                conference: {
                    metaFields: []
                }
            }
        },

        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('rmc/conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            updateOrder: function() {
                let order = [];
                for (let i = 0; i < this.conference.metaFields.length; i++) {
                    order.push(this.conference.metaFields[i].id)
                }
                http.post('rmc/questions/order', {order}).then(response => {

                }).catch(err => {

                });
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    }
</script>

<style>

</style>
